<script>
  import { onMount } from "svelte";

  export let number;
  export let winkel_outer = 33.33;
  export let winkel_innen = 60;
  export let is_total = false;

  export let ist_lead_table = false;
  export let second_position = false;

  export let radius = 37;

  let mounted = false;

  let jahres_anteil = 0;

  onMount(() => {
    draw();
    mounted = true;
  });

  $: {
    winkel_outer, winkel_innen, radius;

    jahres_anteil = (winkel_innen / winkel_outer) * 100;

    if (winkel_outer == 0) {
      jahres_anteil = 100;
    }

    if (mounted && radius) {
      draw();
    }
  }

  function sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  async function draw() {
    await sleep(500);

    var donut_color = "#d7e2dc";
    var outer_color = "#2e8ea8";
    // var outer_color_border = '#9caaa3';
    var outer_color_border = "#ffffff";
    const canvas = document.getElementById("myCanvas" + number.toString());
    const context = canvas.getContext("2d");
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;

    var radius_offset = 3;

    context.clearRect(0, 0, canvas.width, canvas.height);

    var total_offset = 0;

    if (is_total) {
      total_offset = 10;

      context.beginPath();
      context.fillStyle = "#ecf1ee";
      context.strokeStyle = donut_color;
      context.lineWidth = 2;

      context.arc(centerX, centerY, radius, start_on_top(0), start_on_top(100), false);
      context.lineTo(centerX, centerY);
      // context.stroke();
      context.fill();

      context.beginPath();
      context.fillStyle = "#e4ece7";
      context.strokeStyle = donut_color;
      context.lineWidth = 2;

      context.arc(centerX, centerY, radius - radius_offset - total_offset / 2, start_on_top(0), start_on_top(100), false);
      context.lineTo(centerX, centerY);
      // context.stroke();
      context.fill();
    }

    context.beginPath();
    context.fillStyle = "#ffffff";
    context.strokeStyle = donut_color;
    context.lineWidth = 2;

    context.arc(centerX, centerY, radius - radius_offset - total_offset, start_on_top(0), start_on_top(100), false);
    context.lineTo(centerX, centerY);
    context.stroke();
    context.fill();

    context.beginPath();
    context.fillStyle = outer_color;
    context.strokeStyle = outer_color_border;
    context.lineWidth = 4;

    if (is_total) {
      context.lineWidth = 0;
      context.strokeStyle = "#FFFFFFFF";
    }

    context.arc(centerX, centerY, radius, start_on_top(0), start_on_top(percentage_to_einheitskreis(winkel_outer)), false);
    context.lineTo(centerX, centerY);
    context.stroke();
    context.fill();

    context.beginPath();
    context.fillStyle = "#FFFFFF";
    context.strokeStyle = "#FFFFFFFF";

    if (is_total) {
      context.fillStyle = "#f5f8f6";
      context.strokeStyle = "#f5f8f6";
    }

    context.arc(
      centerX,
      centerY,
      radius - radius_offset - total_offset,
      start_on_top(0),
      start_on_top(percentage_to_einheitskreis(100)),
      false,
    );
    context.fill();

    context.beginPath();
    context.fillStyle = donut_color;
    context.lineWidth = 0.25;
    context.strokeStyle = "#2e8ea8";
    context.arc(
      centerX,
      centerY,
      radius - radius_offset - total_offset,
      start_on_top(0),
      start_on_top(percentage_to_einheitskreis(winkel_innen)),
      false,
    );
    context.lineTo(centerX, centerY);
    context.fill();
    context.stroke();
  }

  function start_on_top(x) {
    return x - Math.PI / 2;
  }

  function percentage_to_einheitskreis(p) {
    return (2 * Math.PI * p) / 100;
  }
</script>

<div class="form-group canvas-container" style={second_position ? "height:100%;" : ""}>
  <table class={second_position ? "vertical_center_two" : "vertical-center"}>
    <tr height="170px;" style="text-align: center">
      <td>
        <canvas
          id="myCanvas{number}"
          width={radius * 2 + 5}
          height={radius * 2 + 5}
          style="margin: auto;
    display: block;"
        />
      </td>
    </tr>
  </table>

  <div
    class="vertical-center {second_position ? 'vertical_center_text_two' : ''}"
    height="15px;"
    style="margin-top: 15px; position: absolute; color: #393939;"
  >
    {winkel_innen}%
  </div>

  <div
    class="vertical-center {second_position ? 'vertical_center_text_three' : ''}"
    height="15px;"
    style="margin-top: 28px; position: absolute; color: #4299b0;"
  >
    <nobr>Target {winkel_outer}%</nobr>
  </div>

  <div class={second_position ? "box1teposition" : "box2teposition"} style={ist_lead_table ? "" : ""}>
    <div
      style="background-color: #2E8EA8; height:100%; left:0%; position: absolute; width:{jahres_anteil <= 100 ? jahres_anteil : 100}%;"
    />
    <div style="position: absolute; color: white; left: 10%;">{jahres_anteil.toFixed(0)}%</div>
  </div>
</div>

<style>
  .canvas-container {
    position: relative;
  }

  .box1teposition {
    top: 125%;
    height: 20px;
    width: 50%;
    border: solid #2e8ea8 0.25pt;
    color: white;
    left: 10%;
    position: absolute;
  }

  .box2teposition {
    top: 66px;
    height: 20px;
    width: 80%;
    border: solid #2e8ea8 0.25pt;
    color: white;
    left: 10%;
    position: absolute;
  }

  .vertical-center {
    margin: 0;
    position: absolute;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .vertical_center_text_two {
    left: 35%;
    top: 90%;
  }

  .vertical_center_text_three {
    left: 35%;
    top: 90%;
  }

  .vertical_center_two {
    margin: 0;
    position: absolute;
    left: 35%;
    top: 70%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  div {
    font-size: 12px;
  }
</style>
